import React, { useState } from 'react'
import { AppendTheBelow, CheckboxContainer, CheckboxSection } from './GoogleParamsTab.styled'
import { CodeWrapper } from 'Features/CheqParamsModal/CheqParamsModal.styled'
import { CheckBox, CopyTextButton, StyledText, Tooltip } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'

const UTM_PARAMS_OBJECT = {
  source: 'cq_src=google_ads',
  campaign: 'cq_cmp={campaignid}',
  adGroup: 'cq_con={adgroupid}',
  keyword: 'cq_term={keyword}',
  adType: 'cq_med={adtype}',
  placement: 'cq_plac={placement}',
  network: 'cq_net={network}',
  paidTraffic: 'cq_plt=gp',
} as const

type UtmParamKey = keyof typeof UTM_PARAMS_OBJECT

const UTM_PARAMS_INIT_STATE: Record<UtmParamKey, boolean> = {
  source: true,
  campaign: true,
  adGroup: true,
  keyword: true,
  adType: true,
  placement: true,
  network: true,
  paidTraffic: true,
} as const

const noUtmCode =
  'cq_src=google_ads&cq_cmp={campaignid}&cq_con={adgroupid}&cq_term={keyword}&cq_med={adtype}&cq_plac={placement}&cq_net={network}&cq_plt=gp'

export const UTMParameters = ({ haveUtm }: { haveUtm: boolean }) => {
  const [selectedParameters, setSelectedParameters] = useState(UTM_PARAMS_INIT_STATE)
  const { t } = useTranslation('domainManagement')
  const params = Object.keys(UTM_PARAMS_OBJECT) as UtmParamKey[]

  const toggleParam = (param: UtmParamKey) => () => {
    setSelectedParameters((prev) => ({ ...prev, [param]: !prev[param] }))
  }

  const buildUtmCode = () => {
    const selectedParams = Object.entries(selectedParameters)
      .filter(([, value]) => value)
      .map(([key]) => UTM_PARAMS_OBJECT[key as keyof typeof UTM_PARAMS_OBJECT])

    return selectedParams.join('&')
  }

  return (
    <>
      {haveUtm && (
        <>
          <AppendTheBelow>
            <StyledText variant={'baseBold'}>
              {t('tracking_params_modal.google_tab.select_utms')}
            </StyledText>
          </AppendTheBelow>
          <CheckboxSection>
            {params.map((param) => (
              <CheckboxContainer key={param}>
                <CheckBox isChecked={selectedParameters[param]} onChange={toggleParam(param)} />
                <StyledText variant={'baseLight'} css={{ marginLeft: '$4' }}>
                  {t(`tracking_params_modal.google_tab.params.${param}`)}
                </StyledText>
                <Tooltip
                  tooltiptContent={t(
                    `tracking_params_modal.google_tab.params.${param}_description`
                  )}
                  trigerStyle={{
                    style: {
                      color: 'var(--colors-neutral)',
                      marginLeft: '8px',
                      display: 'flex',
                      alignItems: 'center',
                    },
                  }}
                />
              </CheckboxContainer>
            ))}
          </CheckboxSection>
        </>
      )}
      <AppendTheBelow>
        <StyledText variant={'baseBold'}>
          {t('tracking_params_modal.google_tab.append_the_below')}
        </StyledText>
      </AppendTheBelow>
      <CodeWrapper>{haveUtm ? buildUtmCode() : noUtmCode}</CodeWrapper>
      <CopyTextButton
        value={haveUtm ? buildUtmCode() : noUtmCode}
        buttonText={t('tracking_params_modal.copy')}
        css={{ marginBottom: '$6', marginLeft: '$8', fontWeight: '$b' }}
      />
    </>
  )
}
